import React from 'react';
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DisplaySettingsOutlinedIcon from "@mui/icons-material/DisplaySettingsOutlined";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckoutOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
// import RouteIcon from "@mui/icons-material/Route";
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import InsertLinkIcon from "@mui/icons-material/InsertLink";
import PercentIcon from '@mui/icons-material/Percent';
import ShowChartOutlined from "@mui/icons-material/ShowChartOutlined";
import InsertChartOutlinedRoundedIcon from "@mui/icons-material/InsertChartOutlinedRounded";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import IntegrationInstructionsOutlinedIcon from "@mui/icons-material/IntegrationInstructionsOutlined";
import PowerOutlinedIcon from "@mui/icons-material/PowerOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import UploadFileIcon from "../assets/svg/upload-file-icon-sidebar.svg";
import RouteIcon from "../assets/svg/routing/routing-icon.svg";
import GenerateReportIconNew from "../assets/svg/generate-report-icon.svg"

const sideMenu = [
    {
        name: 'ANALYTICS',
        url: '/home',
        title: 'Home',
        overridePermission: false,
        icon: <HomeOutlinedIcon alt="Home" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'PAYMENT_GATEWAYS',
        url: '/payment_gateway_configurations',
        title: 'Configurations',
        overridePermission: false,
        icon: <DisplaySettingsOutlinedIcon alt="Configurations" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'MERCHANT_SETTINGS',
        url: '/checkout',
        title: 'Checkout',
        overridePermission: false,
        icon: <ShoppingCartCheckoutOutlinedIcon alt="Checkout" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'ORDER_MANAGEMENT',
        url: '/transactions',
        title: 'Transactions',
        overridePermission: false,
        icon: <AssignmentOutlinedIcon alt="Transactions" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'REFUND_REVIEW',
        url: '/approvals',
        title: 'Approval Requests',
        overridePermission: false,
        icon: <PendingActionsIcon alt="Approval Requests" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'PAYMENT_ROUTING_RULES',
        url: '/routing',
        title: 'Routing',
        overridePermission: false,
        icon: <RouteIcon alt="Routing" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'PAYMENT_LINKS',
        url: '/paymentLinks',
        title: 'Payment Links',
        overridePermission: false,
        icon: <InsertLinkIcon alt="Payment Links" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'OFFERS',
        url: '/offerManagement',
        title: 'Offer Management',
        overridePermission: false,
        icon: <PercentIcon alt="Offer Management" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'RECON',
        url: '/paymentReconciliation',
        title: 'Reconciliations',
        overridePermission: true,
        icon: <ShowChartOutlined alt="Reconciliation" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'RECON_RECORD_FILES,RECON_REPORTS',
        url: '/recon',
        title: 'Reconciliations',
        overridePermission: false,
        icon: <ShowChartOutlined alt="Reconciliation" className="iconsSize" />,
        renderSubmenu: true,
        subMenu: [
            {
                name: 'RECON_RECORD_FILES',
                url: '/reconciliation/files',
                title: 'Upload File',
                icon: <UploadFileIcon height={24} width={24} alt='upload recon' className="iconsSize" />,
            },
            {
                name: 'RECON_REPORTS',
                url: '/reconciliation/generateReport',
                title: 'Generate Report',
                icon: <GenerateReportIconNew height={24} width={24} alt='upload recon' className="iconsSize" />,

            },
            {
                name: 'RECON',
                url: '/paymentReconciliation',
                title: 'Payments Recon',
                overridePermission: true,
                icon: <ShowChartOutlined alt="Reconciliation" className="iconsSize" />,
            }
        ]
    },
    {
        name: 'ANALYTICS',
        url: '/analytics',
        title: 'Analytics',
        overridePermission: false,
        icon: <InsertChartOutlinedRoundedIcon alt="Analytics" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'MERCHANT_REPORTS',
        url: '/reports',
        title: 'Reports',
        overridePermission: false,
        icon: <SummarizeOutlinedIcon alt="Reports" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'API_KEYS,WEBHOOKS',
        url: '/developers',
        title: 'Developers',
        overridePermission: false,
        icon: <IntegrationInstructionsOutlinedIcon alt="Developers" className="iconsSize" />,
        renderSubmenu: true,
        subMenu: [
            {
                name: 'API_KEYS',
                url: '/developers/api_credentials',
                title: 'API Credentials',
                icon: <PowerOutlinedIcon alt="API Credentials" className="iconsSize" />,
            },
            {
                name: 'WEBHOOKS',
                url: '/developers/webhooks',
                title: 'Webhook',
                icon: <WebhookOutlinedIcon alt="Webhook" className="iconsSize" />,
            }
        ]
    },
    {
        name: '',
        url: 'https://boxpay.atlassian.net/servicedesk/customer/portal/1',
        target: '_blank',
        title: 'Support',
        overridePermission: true,
        icon: <SupportAgentIcon alt="Support" className="iconsSize" />,
        renderSubmenu: false,
        subMenu: []
    },
    {
        name: 'LEGAL_ENTITIES,PRODUCTS,USER_ROLES_MANAGEMENT',
        url: '/settings',
        title: 'Account & Settings',
        overridePermission: false,
        icon: <SettingsOutlinedIcon alt="Account & Settings" className="iconsSize" />,
        renderSubmenu: true,
        subMenu: [
            {
                name: 'LEGAL_ENTITIES',
                url: '/settings/business_unit',
                title: 'Business Unit',
                icon: <BusinessCenterOutlinedIcon alt="Business Unit" className="iconsSize" />,
            },
            {
                name: 'PRODUCTS',
                url: '/settings/product_catalogue',
                title: 'Product Catalogue',
                icon: <Inventory2OutlinedIcon alt="Product Catalogue" className="iconsSize" />,
            },
            {
                name: 'USER_ROLES_MANAGEMENT',
                url: '/settings/manageTeam',
                title: 'Manage Team',
                icon: <GroupAddOutlinedIcon alt="Manage Team" className="iconsSize" />,
            }
        ]
    },
]

export default sideMenu